import React, { useState } from 'react';
import { makeStyles, Theme, createStyles, Button, ButtonGroup } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup} from '@material-ui/lab';
import { Person as PersonIcon, Info as InfoIcon } from '@material-ui/icons';
import MyInfo from './MyInfo/MyInfo'
import UsersInfo from './UsersInfo/UsersInfo'
import FieldsInfo from './FieldsInfo/FieldsInfo'
import * as Lambda from '../../Lambda';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        height: "100%",
        margin: "8px",
        display: "flex",
        flexDirection: "column",
    },
    buttons: {
        display: "flex"
    },
    space: {
        flexGrow: 1
    },
    content: {
        flexGrow: 1,
    }

  }),
);


interface Props {
    globalSetting?: Lambda.GetMyInfoResponseType | undefined
    onClose?: ()=>void
}

function InfoPanel(props: Props) {

    const classes = useStyles()

    const modeChange = (e: React.MouseEvent<HTMLElement>, value: string | null) => {
        if (value) {
            setMode(value)
        }
    }
    const [mode, setMode] = useState("my")

    return (
        <div className={classes.root}>
            <div className={classes.buttons}>
                <ToggleButtonGroup
                    value={mode}
                    exclusive
                    onChange={modeChange}
                    size="small"
                >
                    <ToggleButton value="my" aria-label="my info">
                        <PersonIcon />
                    </ToggleButton>
                    {/*
                    <ToggleButton value="users" aria-label="users info">
                        <PeopleIcon />
                    </ToggleButton>
                    <ToggleButton value="fields" aria-label="fields info">
                        <NotesIcon />
                    </ToggleButton>
                    */}
                                        
                </ToggleButtonGroup>
                <div className={classes.space} />
                <ButtonGroup 
                    size="small">
                    <Button onClick={()=>props.onClose?.()}><InfoIcon /></Button>
                </ButtonGroup>
            </div>
            <div className={classes.content}>
                { mode === "my" ? <MyInfo /> : null }
                { mode === "users" ? <UsersInfo /> : null }
                { mode === "fields" ? <FieldsInfo /> : null }
            </div>
        </div>
    )
}

export default InfoPanel;